//added by abdullah 
// import layoutsPlugin from '@/plugins/layouts'

import App from '@/App.vue'
import { registerPlugins } from '@core/utils/plugins'
import { createApp } from 'vue'

// Styles
import '@core/scss/template/index.scss'
import '@styles/styles.scss'

import '@fortawesome/fontawesome-free/css/all.css'



// Create vue app
const app = createApp(App)

//added by abdullah 
// app.use(layoutsPlugin)

// Register plugins
registerPlugins(app)

// Mount vue app
app.mount('#app')
